import React from 'react';
import { motion } from 'framer-motion';
import { BinaryRain } from './BinaryRain';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-62">
      <BinaryRain data-id="element-63" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-64">
        {/* Vault Door Illustration */}
        <motion.div initial={{
        scale: 0.8,
        opacity: 0,
        rotate: -30
      }} animate={{
        scale: 1,
        opacity: 1,
        rotate: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="mb-12 relative w-64 h-64 md:w-80 md:h-80" data-id="element-65">
          <svg viewBox="0 0 200 200" className="w-full h-full drop-shadow-[0_0_30px_rgba(0,255,136,0.2)]" data-id="element-66">
            {/* Outer Ring */}
            <circle cx="100" cy="100" r="95" fill="#111118" stroke="#1e1e2e" strokeWidth="2" data-id="element-67" />
            <circle cx="100" cy="100" r="90" fill="none" stroke="#333" strokeWidth="1" strokeDasharray="4 4" data-id="element-68" />

            {/* Bolts */}
            {[...Array(8)].map((_, i) => <circle key={i} cx={100 + 85 * Math.cos(i * Math.PI / 4)} cy={100 + 85 * Math.sin(i * Math.PI / 4)} r="4" fill="#444" data-id="element-69" />)}

            {/* Inner Door */}
            <circle cx="100" cy="100" r="70" fill="url(#metalGradient)" stroke="#1e1e2e" strokeWidth="2" data-id="element-70" />

            {/* Handle Mechanism */}
            <g transform="rotate(45 100 100)" data-id="element-71">
              <rect x="90" y="40" width="20" height="120" rx="2" fill="#222" data-id="element-72" />
              <circle cx="100" cy="100" r="25" fill="#111" stroke="#00ff88" strokeWidth="2" data-id="element-73" />
              <rect x="95" y="50" width="10" height="40" fill="#00ff88" opacity="0.5" data-id="element-74" />
            </g>

            <defs data-id="element-75">
              <linearGradient id="metalGradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-76">
                <stop offset="0%" stopColor="#1a1a24" data-id="element-77" />
                <stop offset="50%" stopColor="#2a2a35" data-id="element-78" />
                <stop offset="100%" stopColor="#1a1a24" data-id="element-79" />
              </linearGradient>
            </defs>
          </svg>

          {/* Glow behind vault */}
          <div className="absolute inset-0 bg-[#00ff88] opacity-10 blur-3xl -z-10 rounded-full" data-id="element-80" />
        </motion.div>

        {/* Text Content */}
        <motion.h1 initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-81">
          YOUR DIGITAL FORTRESS <br data-id="element-82" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00ff88] to-[#00d4ff]" data-id="element-83">
            STARTS HERE
          </span>
        </motion.h1>

        <motion.p initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="text-lg md:text-xl text-[#a0a0b0] max-w-2xl mb-10 leading-relaxed" data-id="element-84">
          Ironkeep shields your credentials, encrypts your data, and stands
          guard against every breach — so you never have to.
        </motion.p>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-85">
          <button className="group relative px-8 py-4 bg-[#00ff88] text-[#0a0a0f] font-bold font-mono rounded overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_20px_rgba(0,255,136,0.5)]" data-id="element-86">
            <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-87">
              INITIALIZE VAULT <ShieldCheck className="w-5 h-5" data-id="element-88" />
            </span>
            <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity" data-id="element-89" />
          </button>

          <button className="group px-8 py-4 bg-transparent border border-[#00d4ff] text-[#00d4ff] font-bold font-mono rounded transition-all hover:bg-[#00d4ff]/10 hover:shadow-[0_0_20px_rgba(0,212,255,0.3)]" data-id="element-90">
            <span className="flex items-center justify-center gap-2" data-id="element-91">
              EXPLORE DEFENSES{' '}
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-92" />
            </span>
          </button>
        </motion.div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#0a0a0f] to-transparent z-10" data-id="element-93" />
    </section>;
}